import { HIGHLIGHT_COLORS } from '../hooks/useHighlights'

interface Props {
  position: { top: number; left: number }
  onHighlight: (color: string) => void
  onClose: () => void
}

export function HighlightPopover({ position, onHighlight, onClose }: Props) {
  return (
    <>
      <div className="highlight-popover-backdrop" onClick={onClose} />
      <div
        className="highlight-popover"
        style={{
          position: 'fixed',
          top: Math.max(10, position.top - 50),
          left: Math.min(
            Math.max(80, position.left),
            window.innerWidth - 80
          ),
          transform: 'translateX(-50%)',
        }}
      >
        <div className="highlight-colors">
          {HIGHLIGHT_COLORS.map(({ name, value }) => (
            <button
              key={value}
              className="highlight-color-btn"
              style={{ backgroundColor: value }}
              onClick={() => onHighlight(value)}
              title={name}
              aria-label={`Highlight ${name}`}
            />
          ))}
        </div>
      </div>
    </>
  )
}
